import { Nullable } from '@/models/Model';

import percentage from './percentage';

export default function toPercent(
  value: Nullable<number>,
  max: Nullable<number>,
): number {
  if (!max) return 0;
  return Math.round(percentage((value ?? 0) / max));
}
